import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import router from '@/router/'
import i18n from './i18n'
import { createStore } from 'vuex'
import 'ant-design-vue/dist/reset.css';
import './assets/main.css'
const store = createStore({
    state :{
        theme: 0
    },
  })
var app=createApp(App).use(i18n);
app.use(router);
app.use(store);
app.use(Antd);
app.mount('#app')
